<template>
	<div id="standardFaultStatis">
		<!-- 饼图 -->
		<div
			id="model"
			style="
				width: calc((100% - 24px) / 3);
				height: 50%;
				min-height: 430px;
				margin-right: 24px;
			"
		>
			<div class="select">
				<el-select
					size="mini"
					class="marginR10 marginL10"
					v-model.trim="pieForm.productTypeId"
					placeholder="产品类型"
					clearable
					@change="(val) => handleChangeProductType(val, 1)"
				>
					<el-option
						v-for="item in productTypes"
						:key="item.id"
						:label="item.productType"
						:value="item.id"
					></el-option>
				</el-select>
				<el-select
					size="mini"
					:disabled="pieForm.productTypeId == ''"
					v-model.trim="pieForm.productId"
					placeholder="产品型号"
					clearable
				>
					<el-option
						v-for="item in productModels1"
						:key="item.id"
						:label="item.productModel"
						:value="item.id"
					></el-option>
				</el-select>
				<el-date-picker
					class="marginT10 marginL10"
					v-model="pieForm.reportTime"
					size="mini"
					value-format="yyyy-MM-dd"
					type="month"
					placeholder="选择日期"
				></el-date-picker>
			</div>
			<div ref="spread" style="width: 100%; height: 100%"></div>
		</div>
		<!-- 柱状图 -->
		<div
			id="spread"
			style="
				width: calc((100% - 24px) / 3 * 2);
				height: 50%;
				min-height: 430px;
			"
		>
			<div class="radio">
				<el-select
					size="mini"
					class="marginT10 marginL10 marginR10"
					v-model.trim="statisticForm.productTypeId"
					placeholder="产品类型"
					clearable
					@change="(val) => handleChangeProductType(val, 2)"
				>
					<el-option
						v-for="item in productTypes"
						:key="item.id"
						:label="item.productType"
						:value="item.id"
					></el-option>
				</el-select>
				<el-select
					size="mini"
					:disabled="statisticForm.productTypeId == ''"
					v-model.trim="statisticForm.productId"
					placeholder="产品型号"
					clearable
				>
					<el-option
						v-for="item in productModels2"
						:key="item.id"
						:label="item.productModel"
						:value="item.id"
					></el-option>
				</el-select>
				<el-date-picker
					class="marginT10 marginL10"
					v-model="statisticForm.reportTime"
					size="mini"
					value-format="yyyy-MM-dd"
					type="month"
					placeholder="选择日期"
				></el-date-picker>
			</div>
			<div ref="spread2" style="width: 100%; height: 100%"></div>
		</div>
		<!-- 曲线图 -->
		<div
			id="faultTrend"
			style="
				width: calc(100%);
				height: calc(50% - 24px);
				margin-top: 23px;
			"
		>
			<div class="inputForm">
				<el-select
					size="mini"
					class="marginT10 marginL10 marginR10"
					v-model.trim="tendencyForm.productTypeId"
					placeholder="产品类型"
					clearable
					@change="(val) => handleChangeProductType(val, 3)"
				>
					<el-option
						v-for="item in productTypes"
						:key="item.id"
						:label="item.productType"
						:value="item.id"
					></el-option>
				</el-select>
				<el-select
					size="mini"
					:disabled="tendencyForm.productTypeId == ''"
					v-model.trim="tendencyForm.productId"
					placeholder="产品型号"
					clearable
				>
					<el-option
						v-for="item in productModels3"
						:key="item.id"
						:label="item.productModel"
						:value="item.id"
					></el-option>
				</el-select>
			</div>
			<div class="pickFrom">
				<el-radio-group
					class="marginL10"
					v-model.trim="tendencyForm.type"
					size="small"
				>
					<el-radio-button label="1">24时</el-radio-button>
					<el-radio-button label="2">月</el-radio-button>
					<el-radio-button label="3">年</el-radio-button>
				</el-radio-group>
			</div>
			<div ref="faultTrend" style="width: 100%; height: 100%"></div>
		</div>
	</div>
</template>

<script>
import indexEcharts from "@/libs/indexEcharts";
export default {
	data() {
		return {
			productTypes: [],
			productModels1: [],
			productModels2: [],
			productModels3: [],
			pieForm: {
				productId: "",
				productTypeId: "",
				reportTime: "",
			},
			statisticForm: {
				productId: "",
				productTypeId: "",
				reportTime: "",
			},
			tendencyForm: {
				productId: "",
				productTypeId: "",
				type: 3,
			},
			faultTrendData: {
				title: "故障趋势",
				subtext: "总数(次)",
				type: "line",
				sname: "2019-6",
				tip: "{b}\n故障总计：{c}",
				name: [],
				value: [],
			},
			spreadData: {
				title: "故障分布",
				subtext: "报警总数(次)",
				tatol: "99999",
				// tip:"{b}<br/>{c}次 {d}%",
				tip: function (params) {
					return (
						params.data.name +
						" " +
						params.data.cen +
						"<br/>" +
						params.data.value +
						"次 " +
						params.percent +
						"%"
					);
				},
				name: [],
				value: [],
			},
			spreadData2: {
				title: "故障分布（次）",
				subtext: "",
				type: "bar",
				tatol: "",
				sname: "2019-6",
				name: [],
				tip: function (params) {
					return (
						params[0].data.name +
						" " +
						params[0].data.cen +
						"<br/>" +
						params[0].data.value +
						"次 "
					);
				},
				value: [],
			},
		};
	},
	watch: {
		pieForm: {
			handler(val, oldVal) {
				this.faultPieStatistics();
			},
			deep: true,
		},
		statisticForm: {
			handler(val, oldVal) {
				this.faultLineStatistics();
			},
			deep: true,
		},
		tendencyForm: {
			handler(val, oldVal) {
				this.faultNewTendency();
			},
			deep: true,
		},
	},
	mounted() {
		this.faultPieStatistics();
		this.faultLineStatistics();
		this.faultNewTendency();
		this.getProductTypesAll();
		const that = this;
		window.onresize = () => {
			return (() => {
				that.$echarts.init(that.$refs.faultTrend).resize();
				that.$echarts.init(that.$refs.spread).resize();
				that.$echarts.init(that.$refs.spread2).resize();
			})();
		};
	},
	methods: {
		// 获取饼状图数据
		faultPieStatistics() {
			this.$http.standFaultPieStatistics(this.pieForm).then((res) => {
				if (res.data.success) {
					this.spreadData.name = [];
					this.spreadData.value = [];
					let list = Object.assign([], res.data.data.datas);
					list.forEach((item) => {
						this.spreadData.name.push(item[0]);
						this.spreadData.value.push({
							name: item[0],
							value: item[1],
							cen: item[2],
						});
					});
					this.spreadData.total = res.data.data.total;
					indexEcharts.model(this.$refs.spread, this.spreadData);
				}
			});
		},
		// 获取折线图数据
		faultLineStatistics() {
			this.$http
				.standFaultLineStatistics(this.statisticForm)
				.then((res) => {
					if (res.data.success) {
						this.spreadData2.name = [];
						this.spreadData2.value = [];
						res.data.data.forEach((x) => {
							this.spreadData2.name.push(x[0]);
							this.spreadData2.value.push({
								name: x[0],
								value: x[1],
								cen: x[2],
							});
						});
						indexEcharts.newTrend(
							this.$refs.spread2,
							this.spreadData2
						);
					}
				});
		},
		// 获取趋势图数据
		faultNewTendency() {
			this.$http.standFaultNewTendency(this.tendencyForm).then((res) => {
				if (res.data.success) {
					this.faultTrendData.name = [];
					this.faultTrendData.value = [];
					res.data.data.forEach((x) => {
						this.faultTrendData.name.push(x[0]);
						this.faultTrendData.value.push(x[1]);
					});
					indexEcharts.newTrend(
						this.$refs.faultTrend,
						this.faultTrendData
					);
				}
			});
		},
		getProductTypesAll: function () {
			this.$http.productTypesAll().then((res) => {
				this.productTypes = res.data.data;
			});
		},
		handleChangeProductType: function (val, num) {
			if (val != "") {
				this.getProductModels(val, num);
			}
			switch (num) {
				case 1:
					this.pieForm.productId = null;
					break;
				case 2:
					this.statisticForm.productId = null;
					break;
				default:
					this.tendencyForm.productId = null;
					break;
			}
		},
		getProductModels: function (val, num) {
			this.$http
				.productModuleAll({
					productTypeId: val,
				})
				.then((res) => {
					if (res.data.success) {
						this["productModels" + num] = res.data.data;
					}
				});
		},
	},
	destroyed() {
		window.onresize = null;
	},
};
</script>

<style lang="less" scoped>
#standardFaultStatis {
	float: left;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	min-width: 1200px;
	min-height: 660px;
	> div {
		border-radius: 4px;
		background: #fff;
		box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
		float: left;
	}
	#model {
		position: relative;
		> p {
			float: left;
			padding: 24px 0 0 24px;
			font-size: 14px;
			color: #59626c;
			font-weight: bold;
		}
		> .select {
			height: 24px;
			top: 54px;
			right: 0px;
			position: absolute;
			z-index: 1;
			&.last {
				width: 110px;
				right: 88px;
			}
			.el-input__icon {
				line-height: 24px;
			}
			input.el-input__inner {
				height: 24px;
			}
		}
	}
	#faultTrend,
	#spread {
		position: relative;
		> .radio {
			top: 12px;
			right: 30px;
			position: absolute;
			z-index: 1;
			.el-radio-button__orig-radio:checked + .el-radio-button__inner {
				background-color: #f02b54;
				border-color: #f02b54;
				box-shadow: -1px 0 0 0 #f02b54;
				color: #fff;
			}
			.el-radio-button__inner:hover {
				color: #f02b54;
			}
		}
		> .inputForm {
			top: 14px;
			left: 130px;
			position: absolute;
			z-index: 1;
		}
		> .pickFrom {
			top: 24px;
			right: 30px;
			position: absolute;
			z-index: 1;
		}
	}
}
</style>
